import { render } from "./PurchaseForm.vue?vue&type=template&id=0235d132&scoped=true"
import script from "./PurchaseForm.vue?vue&type=script&lang=js"
export * from "./PurchaseForm.vue?vue&type=script&lang=js"

import "./PurchaseForm.vue?vue&type=style&index=0&id=0235d132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0235d132"]])

export default __exports__